import { Mod, IdolSize, ContentType } from '../types/mods';
import { modDatabase, formatModDescription } from '../data/mods';
import { Idol } from '../types';

// Convert item type to idol type enum
export const getIdolSizeFromItemType = (itemType: string): IdolSize => {
  const mapping: Record<string, IdolSize> = {
    'MINOR': IdolSize.MINOR,
    'TOTEMIC': IdolSize.TOTEMIC,
    'CONQUEROR': IdolSize.CONQUEROR,
    'KAMASAN': IdolSize.KAMASAN,
    'NOBLE': IdolSize.NOBLE,
    'BURIAL': IdolSize.BURIAL,
  };
  
  return mapping[itemType] || IdolSize.MINOR;
};

// Get random value within the mod's range
export const getRandomValueInRange = (range: [number, number]): number => {
    const [min, max] = range;
    const value = min + Math.random() * (max - min);
    
    // Handle decimal values appropriately
    return Number.isInteger(min) && Number.isInteger(max) 
      ? Math.round(value) 
      : parseFloat(value.toFixed(1));
  };


export const getTextFromModId = (modId: number): string => {
  const mod = modDatabase.mods[modId];
  if (!mod) return 'Unknown effect';
  return mod.description;
}

// Get available prefixes for a specific idol type
export const getAvailablePrefixes = (idolSize: IdolSize): Mod[] => {
  return modDatabase.byIdolSize[idolSize]?.prefixes.map(id => modDatabase.mods[id]) || [];
};

// Get available suffixes for a specific idol type
export const getAvailableSuffixes = (idolSize: IdolSize): Mod[] => {
  return modDatabase.byIdolSize[idolSize]?.suffixes.map(id => modDatabase.mods[id]) || [];
};

// Format all stats in an idol for display
export const formatIdolStats = (idol: Idol): string[] => {
  return idol.stats.map(stat => {
    const mod = modDatabase.mods[stat.modId];
    if (mod) {
      return formatModDescription(mod, stat.value);
    }
    return `${stat.value}% ${getTextFromModId(stat.modId) || 'Unknown effect'}`;
  });
};

// Filter mods by family
export const filterModsByContentType = (mods: Mod[], contentType?: ContentType): Mod[] => {
  if (!contentType) return mods;
  return mods.filter(mod => mod.contentType === contentType);
};

